import { render, staticRenderFns } from "./RoomItemUsers.vue?vue&type=template&id=6690435c"
import script from "./RoomItemUsers.vue?vue&type=script&lang=js"
export * from "./RoomItemUsers.vue?vue&type=script&lang=js"
import style0 from "./RoomItemUsers.vue?vue&type=style&index=0&id=6690435c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports